module.exports = "<button type=\"button\" class=\"primary-btn\" (click)=\"mprint()\">Print</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/print.component.html
// module id = ./src/app/print.component.html
// module chunks = main